import React from "react";
import styled from "styled-components";
import { FlexContainer,PrimaryButton } from "./styled";
import NovaIcon from "../assets/images/logo/tokens/nova.png";
import usePaymentTokenBalance from "../hooks/usePaymentTokenBalance";


const MarketbuyConfirmModalContent = ({onClose,products,onConfirm,totalCost}) => {
    console.log("Products in confirm modal", products);
    const {isLoading,balanceNumber} = usePaymentTokenBalance();

    return(
        <ContentContainer>
          <h3 style={{
            textAlign: "center",
            position:"absolute",
            top:"-36px",
            padding:"0 32px",
          }}>Your receipt</h3> 
            <ProductsContainer>
                {React.Children.toArray(
                products.map(product => (
                    <FlexContainer style={{gap:"8px"}}>
                        <img style={{width:"44px"}} src={product.item.imageUri} alt="Nova Icon" />
                        <span>{product.item.name} ({product.count})</span>
                    </FlexContainer>
                )))}
                <FlexContainer style={{gap:"8px"}}>
                   <strong>Total Cost:</strong><span>{totalCost}</span><img style={{width:"22px"}} src={NovaIcon}  alt="Token"/> 
                </FlexContainer>
            </ProductsContainer>
            <FlexContainer>
                <PrimaryButton style={{maxWidth:"120px"}} onClick={onClose}>Cancel</PrimaryButton>
                <StyledPrimaryButton onClick={onConfirm}>Confirm</StyledPrimaryButton>
            </FlexContainer>
            <FlexContainer>
                <span>Wallet Balance: </span>
                {isLoading ? <StyledText>Loading...</StyledText> : <StyledText>{Number(balanceNumber).toLocaleString(undefined, { maximumFractionDigits: 2 }) || 0}</StyledText>}
            </FlexContainer>
        </ContentContainer>
    )
};
const ContentContainer = styled(FlexContainer)`
    flex-direction: column;
    gap: 0;
    padding: 16px 22px;
    align-items: center;
    overflow-y: auto;
    padding-bottom: 24px;
`;

const ProductsContainer = styled(FlexContainer)`
    width: 100%;
    gap: 8px;
    min-height:68px;
    background: #D9D9D917;
    box-shadow: 0px 4px 22.4px 0px #00000040;
    padding:16px; 
    margin: 16px 0;
    border-radius: 10px;
    flex-direction: column;
    align-items  :flex-start ;
`
const StyledPrimaryButton = styled(PrimaryButton)`
    background: linear-gradient(180deg, #9939AD 12.44%, #40297C 45.28%, #250964 50.97%, #582063 100%);
    backdrop-filter: blur(10.800000190734863px);
    box-shadow: 0px 7px 0px 0px #471964;
    max-width: 120px;
    `
const StyledText = styled.span`
    font-size: 0.8em;
    font-weight: 400;
    font-weight: 600;
    color: #FFFFFF;
    margin: 16px 0;
`
export default MarketbuyConfirmModalContent;